import { errorsProps } from '../components/SummaryErrors/SummaryErrors';

export const fieldHasError = (error: errorsProps, fieldName: string): boolean =>
  error.fieldName === fieldName ||
  (error.affectedFields?.some((f) => f.fieldName === fieldName) ?? false);

export const getFieldErrors = (
  errors: errorsProps[],
  fieldName: string
): string[] =>
  errors
    .filter((e) => fieldHasError(e, fieldName))
    .flatMap((e) => e.fieldErrors);

export const anyFieldHasError = (
  errors: errorsProps[],
  fieldNames: string[]
): boolean => errors.some((e) => fieldNames.some((f) => fieldHasError(e, f)));
